/**
 * O link direto da aba de secrets (spec 2026-10-08 D18): a entrega do ajuste
 * livre comenta no chamado `/recursos?aba=secrets&secret=<arn>`, e a página
 * abre a aba e o drawer daquele secret. Funções puras: a página lê a URL uma
 * vez e as aplica.
 */

const ABAS = new Set(['ec2', 'elb', 'domains', 's3', 'secrets', 'vpn'])

/** A aba inicial: a do link, quando é uma aba que existe; senão EC2. */
export function abaInicial(busca: URLSearchParams): string {
  const aba = busca.get('aba')
  return aba && ABAS.has(aba) ? aba : 'ec2'
}

/** O secret do link, casado pelo ARN (nunca pelo nome). Ausente da lista
 * (inventário ainda sem ele) não abre nada. */
export function secretDoLink<T extends { arn: string }>(busca: URLSearchParams,
                                                          itens: T[]): T | null {
  const arn = busca.get('secret')
  if (!arn) return null
  return itens.find((s) => s.arn === arn) ?? null
}
